export const CART_SELECTION_SNAPSHOT_VERSION = 2 as const;
export const CART_SELECTION_TTL_MS = 30 * 60 * 1_000;

export type CartSelectionScope = {
  site: string;
  currency: string;
  identity: string | null;
};

export type CartSelectionSnapshotV1 = {
  version: typeof CART_SELECTION_SNAPSHOT_VERSION;
  scope: CartSelectionScope;
  selectedCartIds: number[];
  explicitlyEmpty: boolean;
  updatedAt: number;
  expiresAt: number;
};

export type RestoredCartSelection = Pick<
  CartSelectionSnapshotV1,
  'selectedCartIds' | 'explicitlyEmpty'
>;
